import { createFileRoute } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { actionNoConformityQuery } from '@/queries/action-no-conformity.query'

export const Route = createFileRoute('/_dashboard/site/$id/non-conformity/$actionId/')({
  loader({ params, context: { queryClient } }) {
    return queryClient.ensureQueryData(actionNoConformityQuery(params.id, params.actionId))
  },
  pendingComponent: PendingComponent,
})
